import { TIconSize, TQueries } from '@src/models/common';
import { CSSProperties } from 'react';

const getIconsSize = (size: number): CSSProperties => ({
  minHeight: size,
  minWidth: size,
  height: size,
  width: size,
});

export const getAdaptiveIconsSize = (size: TIconSize, br: keyof TQueries | undefined): CSSProperties | undefined => {
  return typeof size === 'number' ? getIconsSize(size) : br && size[br] ? getIconsSize(size[br]) : undefined;
};
